import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function WeeklyOntimeDeliveryRateKpi (props){

    const table = "VwDeliveryComplianceWeekly";
    const view = "VwDeliveryComplianceWeekly";

    const { filterValue, onFilterInitialized, onSearchInitialized, onModifyViewSchema } = props;

    const [ api, setApi ] = useState ( null );

    useEffect ( () => {

        if ( api ) {

            api.refresh ();

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ api ] );


    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    return (
    
        
        <BasicCrudScreenType
            id="WeeklyOntimeDeliveryRateKpi"
            noHeader
            table={table}
            view={view}
            extFilterValue={filterValue}
            onModifyViewSchema={onModifyViewSchema}
            onFilterInitialized={onFilterInitialized}
            onSearchInitialized={onSearchInitialized}
            onApiInitialized={onApiInitialized}
        />

    );

}
export default WeeklyOntimeDeliveryRateKpi;